import * as React from 'react'
import { MobXProviderContext } from 'mobx-react'

import BasicRootStore from 'Core/stores/basicRootStore/BasicRootStore'

const useBasicStores = <PortalRootStore extends BasicRootStore>(): PortalRootStore =>
	React.useContext(MobXProviderContext).rootStore

export default useBasicStores
